export const buildQueryParam = (key: string, values?: any): string | null => {
  if (Array.isArray(values) && values.length) {
    const formattedValues = values.map((val) =>
      val instanceof Date ? val.toISOString() : val
    );
    return `${key}[]=${formattedValues.join(`&${key}[]=`)}`;
  } else if (
    (typeof values === "string" && values.length) ||
    typeof values === "number" ||
    typeof values === "boolean"
  ) {
    return `${key}=${values}`;
  }
  return null;
};
